import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletRequestReadSlice = createSlice({
  name: "BookletRequestReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletRequestRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletRequestRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletRequestRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletRequestRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletRequestRead,
  failureBookletRequestRead,
  successBookletRequestRead,
  clearBookletRequestRead,
} = BookletRequestReadSlice.actions;

export default BookletRequestReadSlice.reducer;
